/**
 * Cart Drawer — uses the old custom_cart pattern (js-menu__expanded_cart)
 * Product Modal — uses the old js-menu pattern (js-menu__expanded)
 */

const StikCartDrawer = {
  sectionId: 'cart-drawer',
  opener: null,

  init() {
    this.cartEl = document.getElementById('custom_cart_cart');
    this.cartInner = document.getElementById('main-nav-cart');
    this.bindEvents();
    this.initAcceleratedCheckoutGrid();
    this.syncEmptyState();
  },

  initAcceleratedCheckoutGrid() {
    var gridStyles = [
      '.wallet-cart-grid {',
      '  display: grid !important;',
      '  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;',
      '  grid-auto-flow: row !important;',
      '  gap: 10px !important;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '  justify-content: stretch !important;',
      '}',
      '.wallet-cart-button-container, .wallet-cart-button {',
      '  width: 100% !important;',
      '  min-width: 0 !important;',
      '  height: clamp(25px, var(--shopify-accelerated-checkout-button-block-size, 44px), 55px) !important;',
      '  margin: 0 !important;',
      '}',
    ].join('\n');

    var enhance = function(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('shopify-accelerated-checkout-cart').forEach(function(host) {
        if (typeof host.getOrCreateShadowRoot !== 'function') return;

        try {
          var shadow = host.getOrCreateShadowRoot();
          if (!shadow || !shadow.querySelector('.wallet-cart-grid')) return;
          if (shadow.getElementById('stikwood-wallet-grid')) return;

          var style = document.createElement('style');
          style.id = 'stikwood-wallet-grid';
          style.textContent = gridStyles;
          shadow.appendChild(style);
        } catch (err) {
          console.warn('Could not enhance accelerated checkout layout', err);
        }
      });
    };

    this.enhanceAcceleratedCheckoutGrid = function() {
      enhance(document);
    };
    enhance(document);
    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('shopify-accelerated-checkout-cart').then(function() {
        enhance(document);
        window.setTimeout(function() { enhance(document); }, 100);
        window.setTimeout(function() { enhance(document); }, 500);
      });
    }
  },

  bindEvents() {
    document.addEventListener('click', (e) => {
      const action = e.target.closest('[data-action]');
      if (!action) return;

      if (action.dataset.action === 'open-cart') {
        e.preventDefault();
        this.open(action);
      } else if (action.dataset.action === 'remove') {
        e.preventDefault();
        this.removeItem(action.dataset.key);
      } else if (action.dataset.action === 'edit') {
        e.preventDefault();
        // Close cart drawer, open product modal in edit mode
        const returnCartOpener = this.opener || document.querySelector('[data-cart-link]');
        this.close(false);
        if (typeof ProductModal !== 'undefined' && action.dataset.productHandle) {
          ProductModal.open(action.dataset.productHandle, {
            editLineKey: action.dataset.lineKey,
            returnCartOpener,
            variantId: action.dataset.variantId,
            quantity: parseInt(action.dataset.quantity) || 1,
            properties: this.parseProperties(action.dataset.properties),
          }, action);
        }
      } else if (action.dataset.action === 'close-cart') {
        e.preventDefault();
        this.close();
      }
    });

    document.addEventListener('change', (e) => {
      if (e.target.dataset.action === 'update-quantity') {
        this.updateQuantity(e.target.dataset.key, parseInt(e.target.value));
      }
    });

    document.addEventListener('keydown', (e) => {
      if (!this.cartInner || !this.cartInner.classList.contains('js-menu__expanded_cart')) return;
      if (window.ProductModal?.isOpen()) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        this.close();
        return;
      }
      if (e.key !== 'Tab') return;
      window.StikDialogIsolation?.moveFocus(e, this.cartInner);
    });
  },

  open(opener) {
    this.opener = opener || document.activeElement;
    if (this.cartEl) this.cartEl.classList.add('js-menu__expanded_cart');
    if (this.cartInner) {
      this.cartInner.classList.add('js-menu__expanded_cart');
      this.cartInner.setAttribute('aria-hidden', 'false');
      window.StikDialogIsolation?.sync();
      window.requestAnimationFrame(() => window.StikDialogIsolation?.focusFirst(this.cartInner));
    }
    if (this.enhanceAcceleratedCheckoutGrid) {
      this.enhanceAcceleratedCheckoutGrid();
      window.setTimeout(this.enhanceAcceleratedCheckoutGrid, 100);
    }
  },

  close(restoreFocus) {
    if (this.cartEl) this.cartEl.classList.remove('js-menu__expanded_cart');
    if (this.cartInner) {
      this.cartInner.classList.remove('js-menu__expanded_cart');
      this.cartInner.setAttribute('aria-hidden', 'true');
    }
    window.StikDialogIsolation?.sync();
    if (restoreFocus !== false && this.opener && typeof this.opener.focus === 'function') this.opener.focus();
    this.opener = null;
  },

  async addItem(variantId, quantity, properties, options = {}) {
    quantity = quantity || 1;
    properties = properties || {};
    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity, properties: properties }],
          sections: this.sectionId,
        }),
      });
      if (!response.ok) throw new Error('Add to cart failed');
      var data = await response.json();
      this.renderSection(data.sections[this.sectionId]);
      if (options.open !== false) this.open(options.opener);
      this.refreshAffirm();
      return data;
    } catch (err) {
      console.error('StikCartDrawer.addItem:', err);
      throw err;
    }
  },

  async replaceItem(oldLineKey, variantId, quantity, properties) {
    properties = properties || {};
    var beforeResponse = await fetch('/cart.js');
    if (!beforeResponse.ok) throw new Error('Could not read cart before replacement');
    var beforeCart = await beforeResponse.json();

    var addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity, properties: properties }],
      }),
    });
    if (!addResponse.ok) throw new Error('Replacement add failed');
    var addedData = await addResponse.json();
    var addedItem = addedData.items && addedData.items[0];
    var addedKey = addedItem && addedItem.key;
    var previousAddedLine = beforeCart.items.find(function(item) {
      return item.key === addedKey;
    });
    var rollbackQuantity = previousAddedLine ? previousAddedLine.quantity : 0;

    try {
      var removeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: oldLineKey,
          quantity: 0,
          sections: this.sectionId,
        }),
      });
      if (!removeResponse.ok) throw new Error('Original line removal failed');
      var removeData = await removeResponse.json();
      this.renderSection(removeData.sections[this.sectionId]);
      this.refreshAffirm();
      return removeData;
    } catch (err) {
      if (addedKey) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: addedKey, quantity: rollbackQuantity }),
        });
      }
      throw err;
    }
  },

  async updateQuantity(key, quantity) {
    try {
      var response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: this.sectionId }),
      });
      if (!response.ok) throw new Error('Update failed');
      var data = await response.json();
      this.renderSection(data.sections[this.sectionId]);
      this.refreshAffirm();
    } catch (err) {
      console.error('StikCartDrawer.updateQuantity:', err);
      throw err;
    }
  },

  async removeItem(key) {
    return this.updateQuantity(key, 0);
  },

  renderSection(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var newContent = parsed.querySelector('#cart-drawer-content');
    var currentContent = document.querySelector('#cart-drawer-content');
    if (newContent && currentContent) {
      currentContent.innerHTML = newContent.innerHTML;
    }
    // Update cart count badges
    var newCount = parsed.querySelector('.cart-drawer-count');
    if (newCount) {
      document.querySelectorAll('.cart-drawer-count').forEach(function(el) {
        el.textContent = newCount.textContent;
        if (el.id === 'itemCount') el.setAttribute('aria-label', newCount.getAttribute('aria-label'));
      });
      this.updateCartLinkLabels(newCount.textContent);
    }
    // Update cart total
    var newTotal = parsed.querySelector('#cart_total');
    var currentTotal = document.querySelector('#cart_total');
    if (newTotal && currentTotal) {
      currentTotal.textContent = newTotal.textContent;
    }
    this.syncEmptyState();
    if (this.enhanceAcceleratedCheckoutGrid) {
      this.enhanceAcceleratedCheckoutGrid();
      window.setTimeout(this.enhanceAcceleratedCheckoutGrid, 100);
    }
  },

  updateCartLinkLabels(countText) {
    var count = parseInt(countText, 10) || 0;
    var itemLabel = count === 1 ? 'item' : 'items';
    document.querySelectorAll('[data-cart-link], #cart-drawer-toggle').forEach(function(link) {
      link.setAttribute('aria-label', 'Shopping cart, ' + count + ' ' + itemLabel);
    });
  },

  refreshAffirm() {
    if (typeof affirm !== 'undefined' && affirm.ui) {
      try { affirm.ui.refresh(); } catch (e) {}
    }
  },

  syncEmptyState() {
    var emptyCta = document.querySelector('.cart-inner--empty-cta');
    if (!emptyCta) return;
    emptyCta.hidden = window.location.href.toLowerCase().indexOf('contract') !== -1;
  },

  parseProperties(value) {
    if (!value) return {};
    try {
      return JSON.parse(value);
    } catch (err) {
      console.warn('Could not parse cart line properties', err);
      return {};
    }
  },
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { StikCartDrawer.init(); });
} else {
  StikCartDrawer.init();
}

window.StikCartDrawer = StikCartDrawer;
